<template>
  <div>
    <!-- Common Component -->
    <b-container fluid>
     <BaseObject
        :object="object"
        :isNew="isNew"
        :payloads="basicItems"
        @input="reflectBasicItem"
      />
      <!-- built in Component -->
      <ChildList
        :items="basicItems.system_functions.items"
        :object="object"
        :parent_id="basicItems.no"
        v-if="!isNew"
      />
      <!-- Common Component -->
      <b-row align-h="center">
        <template >
          <button type="button" class="btn btn-info button_spacer" v-if="isNew" @click="createSystemSpecification">作成</button>
          <button type="button" class="btn btn-info button_spacer" @click="updateSystemSpecification" v-else>変更</button>
        </template>
        <button
          @click="displayResumeModal = !displayResumeModal"
          class="btn btn-outline-secondary"
        >戻る</button>
      </b-row>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？？</p>
        </b-row>
        <b-row align-h="around">
          <router-link
            class="btn btn-outline-secondary"
            to="/"
          >はい</router-link>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import BaseObject from '../../common_parts/BaseObject.vue'
import ChildList from '../../common_parts/ChildList.vue'
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'SystemSpecification',
  components: {
    BaseObject,
    ChildList
  },
  data () {
    return {
      object: '',
      isNew: '',
      id: '',
      parent_id: '',
      basicItems: {
        no: '',
        name: '',
        version: '',
        revision_symbol: '',
        description: '',
        restrictions: '',
        status: '',
        system_functions: {
          items: []
        }
      },
      toast: {},
      displayResumeModal: false
    }
  },
  computed: {
    ...mapState(['version'])
  },
  async created () {
    this.object = this.$route.path.split('/')[1]
    // to change the attribute of route params
    this.id = this.$route.params.systemSpecificationId
    if (this.id) {
      const specification = await API.graphql(graphqlOperation(`
        query getFunctionSpecification {
          getSystemSpecification(no: ${this.id}, version: "${this.version}"){
            no
            name
            version
            revision_symbol
            description
            restrictions
            status
            system_functions {
              items {
                no
                name
                version
              }
            }
          }
        }
      `))
      // to check query result
      if (specification.data.getSystemSpecification) {
        this.basicItems = { ...specification.data.getSystemSpecification }
      } else {
        this.$router.push('/' + this.object)
      }
    } else {
      this.isNew = true
      this.id = this.$route.query.parent
      this.basicItems.name = 'システム仕様1'
      this.basicItems.no = 1
    }
  },
  methods: {
    reflectBasicItem (event) {
      this.basicItems = { ...event }
    },
    makeToast (title, message, variant = 'default') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    async updateSystemSpecification () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? 'revision_symbol: null\n' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        const request = `mutation updateSystemSpecification {
          updateSystemSpecification(input:{
            ${requestBody}
          }){
            no
            version
            name
            revision_symbol
            description
            restrictions
          }
        }`
        this.$log.debug('=====SystemSpecification Update Input=====', request)
        const response = await API.graphql(graphqlOperation(request))
        this.makeToast('正常終了', `${this.translate[this.object]}更新が完了しました。`, 'info')
        this.$log.debug('=====SystemSpecification Update Success=====', response)
        this.$router.go()
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====SystemSpecification Update Error=====', e)
      }
    },
    async createSystemSpecification () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.revision_symbol === '' || this.basicItems.revision_symbol === null ? 'revision_symbol: null\n' : `revision_symbol: "${this.basicItems.revision_symbol}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' || this.basicItems.description === null ? 'description: null\n' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.restrictions === '' || this.basicItems.restrictions === null ? 'restrictions: null\n' : `restrictions: "${this.basicItems.restrictions.replace(/\r?\n/g, '\\n')}"\n`
        const response = await API.graphql(graphqlOperation(`mutation createSystemSpecification {
          createSystemSpecification(input:{
            ${requestBody}
          }){
            no
            version
            name
          }
        }`))
        this.makeToast('正常終了', `${this.translate[this.object]}作成が完了しました。`, 'info')
        this.$log.debug('=====SystemSpecification Create=====', response)
        await this.$router.push(`/system_specification/${response.data.createSystemSpecification.no}`)
        this.$router.go()
      } catch (e) {
        this.$log.debug('=====SystemSpecification Create Error=====', e)
        const isConditionalError = e.errors.some(
          function (elm) {
            return elm.message.includes('ConditionalCheckFailedException')
          }
        )
        if (isConditionalError) {
          this.makeToast('失敗', `作成に失敗しました。\nNoが重複していないかご確認ください。`, 'danger')
        } else {
          this.makeToast('失敗', '作成に失敗しました。\n必須項目の入力漏れがないかご確認ください。', 'danger')
        }
      }
    }
  }
}
</script>
